export default "__VITE_ASSET__CIAXaraC__"